import {reactive, computed} from 'vue';

export default function DriverOnboardingReviewSubmit(data = {}) {
    const state = reactive({
        agreedToTerms: data.agreedToTerms ?? false,
        agreedToBackgroundCheck: data.agreedToBackgroundCheck ?? false,
        agreedToEligibility: data.agreedToEligibility ?? false,
        agreedToAccuracy: data.agreedToAccuracy ?? false,
        notes: data.notes || '',
    });

    const validations = {
        hasAgreed: computed(() => !!state.agreedToTerms),
        hasAgreedToBackgroundCheck: computed(() => !!state.agreedToBackgroundCheck),
        hasAgreedToEligibility: computed(() => !!state.agreedToEligibility),
        hasAgreedToAccuracy: computed(() => !!state.agreedToAccuracy),
    };

    const isValid = () => (
        validations.hasAgreed.value &&
        validations.hasAgreedToBackgroundCheck.value &&
        validations.hasAgreedToEligibility.value &&
        validations.hasAgreedToAccuracy.value
    );

    const toJSON = () => ({...state});

    return {state, validations, isValid, toJSON};
}
